import { useImpersonation } from '@/contexts/ImpersonationContext'

export function ImpersonationBar() {
  const { isImpersonating, orgName, endImpersonation } = useImpersonation()

  if (!isImpersonating) return null

  return (
    <div className="bg-amber-100 border-b border-amber-300 px-4 py-2 flex items-center justify-between">
      <div className="flex items-center gap-2">
        <svg className="w-5 h-5 text-amber-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
        </svg>
        <span className="text-sm font-medium text-amber-800">
          Viewing as <strong>{orgName}</strong> — Read-only
        </span>
      </div>
      <button
        onClick={() => { void endImpersonation() }}
        className="text-sm font-medium text-amber-800 hover:text-amber-900 bg-amber-200 hover:bg-amber-300 px-3 py-1 rounded transition-colors"
      >
        End Impersonation
      </button>
    </div>
  )
}
